//admin

export const LEVEL_TYPE = [
  { id: 1, value: "Beginner" },
  { id: 2, value: "Intermediate" },
  { id: 3, value: "Advanced" },

]
